import React from 'react'

const Register = () => {
  return (
    <div style={{marginTop:"80px"}}>Register</div>
  )
}

export default Register